import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext, useMemo, useState } from 'react';
import { Button } from '@mui/material';
import { all } from 'z3k-parser/validation/collections';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { set_ui_settings } from 'console/redux/settings-actions';
import { minMaxStr, notEmpty } from 'z3k-parser/validation/basic';
import { TextInputWrapper } from 'console/shared/components/fields/text';
import { DeviceUISettingsControl } from 'console/shared/contexts/device-ui-settings/control/types';
import { Control } from 'console/shared/components/fields/control';
import { useAction } from 'shared/hooks/redux/hooks';
export const RenamePanelDialog = memo(function RenamePanelDialog(props) {
    const { onClose, open } = props;
    const { onAddCustomPanel, grouping_panel_key, onChangeCustomPanelName } = useContext(DeviceUISettingsControl);
    const setUiSettings = useAction(set_ui_settings);
    const [name, setName] = useState('');
    const onConfirmName = useCallback((event) => {
        if (grouping_panel_key) {
            onChangeCustomPanelName(grouping_panel_key, name);
        }
        else {
            onAddCustomPanel(name);
        }
        setUiSettings({ grouping_mode: true });
        setName('');
        onClose(event);
    }, [name]);
    const onChangeName = useCallback((name) => {
        setName(name);
    }, []);
    const validate = useMemo(() => (name ? all(notEmpty, minMaxStr(0, 150))(name) : null), [name]);
    return (_jsx(MessageBox, { open: open, onClose: onClose, maxWidth: "xs", title: "\u0418\u043C\u044F \u0433\u0440\u0443\u043F\u043F\u044B", footer: _jsxs(_Fragment, { children: [_jsx(Button, { onClick: onClose, color: "primary", children: "\u041E\u0442\u043C\u0435\u043D\u0430" }), _jsx(Button, { onClick: onConfirmName, disabled: validate != null, color: "primary", children: "\u041F\u0440\u0438\u043D\u044F\u0442\u044C" })] }), children: _jsx(Control, { label: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0440\u0430\u0437\u0434\u0435\u043B\u0430", value: name, onChange: onChangeName, field: (input_props) => (_jsx(TextInputWrapper, { ...input_props, autoFocus: true, placeholder: "\u041D\u043E\u0432\u044B\u0439 \u0440\u0430\u0437\u0434\u0435\u043B" })), validation_result: validate, validation_warnings_result: null }) }));
});
